import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import parse, { DOMNode, domToReact, Element, HTMLReactParserOptions } from "html-react-parser";
import * as React from "react";

export const xParserOptions: HTMLReactParserOptions = {
    replace: (node, index) => {
        const { name, children, attribs = { style: "" }, ...rest } = node as Element;
        const { style, class: className, ...otherAttribs } = attribs;

        otherAttribs.className = className;

        if (name && ["html", "body"].includes(name) && children) {
            return <>{children && domToReact(children as DOMNode[], xParserOptions)}</>;
        }
        if (name === "head") {
            return <></>;
        }
        return parserOptions.replace?.(node, index);
    },
};

export const xParse = parse;
